module.exports = __webpack_public_path__ + "img/تبلیغاتی.8166942a.jpg";